import { Button, Row, Space, Tooltip } from 'antd'
import Search from '../../../components/SearchFilter'
import TableAntd from '../../../components/TableAntd'
import UseLanderInvoiceEntryHook from './hooks'
import Styles from './styles.module.scss'
import { QuestionCircleOutlined } from '@ant-design/icons'
import _ from 'lodash'
import IframeModal from '../../../components/IframeModal'
import { formatTime } from '@/tools/util'
import { RedInvoiceEntryItem } from '@/api/orderManage'
import AsyncButton from '@/components/AsyncButton'
// 订单状态字典
export const orderStateDict = {
  待履约: {
    numstr: '1',
    name: '待履约',
  },
  履约中: {
    numstr: '2',
    name: '履约中',
  },
  待验收: {
    numstr: '3',
    name: '待验收',
  },
  已完成: {
    numstr: '4',
    name: '已完成',
  },
  已取消: {
    numstr: '5',
    name: '已取消',
  },
  已退货: {
    numstr: '6',
    name: '已退货',
  },
  已撤回: {
    numstr: '7',
    name: '已撤回',
  },
}
export const orderStateDictInvert = _.mapKeys(orderStateDict, (o) => o.numstr)

const LanderInvoiceEntry = () => {
  const {
    state,
    handlePaginationChange,
    handleTableChangeCheck,
    handleSearchClick,
    handleBatchRecord,
    changeInvoiceTip,
    exportDetails,
    onJumpDetail,
  } = UseLanderInvoiceEntryHook()
  const { dataSource, invoiceTip, pages, loading } = state
  const columns = [
    {
      key: 'orderNo',
      dataIndex: 'orderNo',
      title: '客户订单号',
      // render: orderDetailLinkRender,
    },
    {
      key: 'blueInvoiceInfos',
      dataIndex: 'blueInvoiceInfos',
      title: '客户订单已开蓝票',
      render: (text: any, record: RedInvoiceEntryItem) => {
        const blueInvoiceNumList = record?.blueInvoiceInfos || []

        return blueInvoiceNumList.map((item, index) => {
          return (
            <>
              <span
                className="primaryBtn"
                onClick={() => onJumpDetail(record, item)}
              >
                {item.invoiceNum}
              </span>
              <span>{index !== blueInvoiceNumList.length - 1 ? ',' : ''}</span>
            </>
          )
        })
      },
    },
    {
      key: 'returnNo',
      dataIndex: 'returnNo',
      title: '退货单号',
    },
    {
      key: 'customerName',
      dataIndex: 'customerName',
      title: '客户名称',
    },
    {
      key: 'consignee',
      dataIndex: 'consignee',
      title: '收件人',
    },
    {
      key: 'platform',
      dataIndex: 'platform',
      title: '下单平台',
    },
    {
      key: 'titleOfTheContractName',
      title: '签约抬头',
      titleRender: () => (
        <>
          签约抬头
          <Tooltip
            title="此订单与咸亨实际的合同签约抬头，发票的购方和最终咸亨打款账户均以此抬头为准"
            getPopupContainer={() => document.body}
          >
            <QuestionCircleOutlined style={{ marginLeft: '5px' }} />
          </Tooltip>
        </>
      ),
      render: (text: string) => text || '万聚国际（杭州）供应链有限公司',
    },
    {
      key: 'returnTime',
      dataIndex: 'returnTime',
      title: '退货时间',
      render: (text: any) => formatTime(text),
    },
    {
      key: 'taxRate',
      dataIndex: 'taxRate',
      title: '税率',
      render: (text: number) => `${(text ?? 0) * 100}%`,
    },
    {
      key: 'returnAmount',
      dataIndex: 'returnAmount',
      title: '退货金额',
    },
  ]
  return (
    <div className={Styles['container']}>
      <Search
        fieldsData={[
          'orderNo',
          'blueInvoiceNum',
          'returnNo',
          'customerName',
          'consignee',
          'platformCode',
          'titleOfTheContract',
          'returnTime',
          'returnStartTime',
          'returnEndTime',
          // 'customer',
          // 'receiveMan',
          // 'platform',
          // 'signVoucher',
          // 'customerPayback',
          // 'orderTimeStart',
          // 'orderTimeEnd',
          // 'dispatchTimeStart',
          // 'dispatchTimeEnd',
        ]}
        onSearch={handleSearchClick}
        keyName="REDLANDERINVOICEENTRY"
        ScreenKey="REDLANDERINVOICEENTRY"
      />
      <Row justify="space-between" className={Styles['info-row']}>
        <Space style={{ cursor: 'pointer' }}>
          <div></div>
          {/* <Tooltip title="订单全部发货">
            <QuestionCircleOutlined style={{ marginRight: '8px' }} />
            可开票订单条件
          </Tooltip> */}
        </Space>
        <Space>
          <Button size="middle" onClick={() => changeInvoiceTip(true)}>
            开票要求
          </Button>
          <AsyncButton size="middle" onClick={exportDetails}>
            明细导出
          </AsyncButton>
          <Button
            type="primary"
            size="middle"
            onClick={handleBatchRecord}
            danger
          >
            红票录入
          </Button>
        </Space>
      </Row>
      <TableAntd
        dataSource={dataSource.data}
        listColumn={columns}
        loading={loading}
        Y={340}
        pagination={{
          total: dataSource.total,
          current: pages.pageNo,
          pagesize: pages.pageSize,
          onChange: handlePaginationChange,
        }}
        showSize={true}
        onChangeCheck={handleTableChangeCheck}
      ></TableAntd>
      {/* 开票要求 */}
      <IframeModal
        open={invoiceTip}
        closeModal={() => changeInvoiceTip(false)}
        srcUrl="https://alidocs.dingtalk.com/i/p/Dnb9XJD9MAgGyAp7VJqzq2dJVg4eEXYE"
      />
    </div>
  )
}

export default LanderInvoiceEntry
import { Button, Row, Space, Tooltip } from 'antd'
import Search from '../../../components/SearchFilter'
import TableAntd from '../../../components/TableAntd'
import UseLanderInvoiceEntryHook from './hooks'
import Styles from './styles.module.scss'
import { QuestionCircleOutlined } from '@ant-design/icons'
import _ from 'lodash'
import IframeModal from '../../../components/IframeModal'
import { formatTime } from '@/tools/util'
import { RedInvoiceEntryItem } from '@/api/orderManage'
import AsyncButton from '@/components/AsyncButton'
// 订单状态字典
export const orderStateDict = {
  待履约: {
    numstr: '1',
    name: '待履约',
  },
  履约中: {
    numstr: '2',
    name: '履约中',
  },
  待验收: {
    numstr: '3',
    name: '待验收',
  },
  已完成: {
    numstr: '4',
    name: '已完成',
  },
  已取消: {
    numstr: '5',
    name: '已取消',
  },
  已退货: {
    numstr: '6',
    name: '已退货',
  },
  已撤回: {
    numstr: '7',
    name: '已撤回',
  },
}
export const orderStateDictInvert = _.mapKeys(orderStateDict, (o) => o.numstr)

const LanderInvoiceEntry = () => {
  const {
    state,
    handlePaginationChange,
    handleTableChangeCheck,
    handleSearchClick,
    handleBatchRecord,
    changeInvoiceTip,
    exportDetails,
    onJumpDetail,
  } = UseLanderInvoiceEntryHook()
  const { dataSource, invoiceTip, pages, loading } = state
  const columns = [
    {
      key: 'orderNo',
      dataIndex: 'orderNo',
      title: '客户订单号',
      // render: orderDetailLinkRender,
    },
    {
      key: 'blueInvoiceInfos',
      dataIndex: 'blueInvoiceInfos',
      title: '客户订单已开蓝票',
      render: (text: any, record: RedInvoiceEntryItem) => {
        const blueInvoiceNumList = record?.blueInvoiceInfos || []

        return blueInvoiceNumList.map((item, index) => {
          return (
            <>
              <span
                className="primaryBtn"
                onClick={() => onJumpDetail(record, item)}
              >
                {item.invoiceNum}
              </span>
              <span>{index !== blueInvoiceNumList.length - 1 ? ',' : ''}</span>
            </>
          )
        })
      },
    },
    {
      key: 'returnNo',
      dataIndex: 'returnNo',
      title: '退货单号',
    },
    {
      key: 'customerName',
      dataIndex: 'customerName',
      title: '客户名称',
    },
    {
      key: 'consignee',
      dataIndex: 'consignee',
      title: '收件人',
    },
    {
      key: 'platform',
      dataIndex: 'platform',
      title: '下单平台',
    },
    {
      key: 'titleOfTheContractName',
      title: '签约抬头',
      titleRender: () => (
        <>
          签约抬头
          <Tooltip
            title="此订单与咸亨实际的合同签约抬头，发票的购方和最终咸亨打款账户均以此抬头为准"
            getPopupContainer={() => document.body}
          >
            <QuestionCircleOutlined style={{ marginLeft: '5px' }} />
          </Tooltip>
        </>
      ),
      render: (text: string) => text || '万聚国际（杭州）供应链有限公司',
    },
    {
      key: 'returnTime',
      dataIndex: 'returnTime',
      title: '退货时间',
      render: (text: any) => formatTime(text),
    },
    {
      key: 'taxRate',
      dataIndex: 'taxRate',
      title: '税率',
      render: (text: number) => `${(text ?? 0) * 100}%`,
    },
    {
      key: 'returnAmount',
      dataIndex: 'returnAmount',
      title: '退货金额',
    },
  ]
  return (
    <div className={Styles['container']}>
      <Search
        fieldsData={[
          'orderNo',
          'blueInvoiceNum',
          'returnNo',
          'customerName',
          'consignee',
          'platformCode',
          'titleOfTheContract',
          'returnTime',
          'returnStartTime',
          'returnEndTime',
          // 'customer',
          // 'receiveMan',
          // 'platform',
          // 'signVoucher',
          // 'customerPayback',
          // 'orderTimeStart',
          // 'orderTimeEnd',
          // 'dispatchTimeStart',
          // 'dispatchTimeEnd',
        ]}
        onSearch={handleSearchClick}
        keyName="REDLANDERINVOICEENTRY"
        ScreenKey="REDLANDERINVOICEENTRY"
      />
      <Row justify="space-between" className={Styles['info-row']}>
        <Space style={{ cursor: 'pointer' }}>
          <div></div>
          {/* <Tooltip title="订单全部发货">
            <QuestionCircleOutlined style={{ marginRight: '8px' }} />
            可开票订单条件
          </Tooltip> */}
        </Space>
        <Space>
          <Button size="middle" onClick={() => changeInvoiceTip(true)}>
            开票要求
          </Button>
          <AsyncButton size="middle" onClick={exportDetails}>
            明细导出
          </AsyncButton>
          <Button
            type="primary"
            size="middle"
            onClick={handleBatchRecord}
            danger
          >
            红票录入
          </Button>
        </Space>
      </Row>
      <TableAntd
        dataSource={dataSource.data}
        listColumn={columns}
        loading={loading}
        Y={340}
        pagination={{
          total: dataSource.total,
          current: pages.pageNo,
          pagesize: pages.pageSize,
          onChange: handlePaginationChange,
        }}
        showSize={true}
        onChangeCheck={handleTableChangeCheck}
      ></TableAntd>
      {/* 开票要求 */}
      <IframeModal
        open={invoiceTip}
        closeModal={() => changeInvoiceTip(false)}
        srcUrl="https://alidocs.dingtalk.com/i/p/Dnb9XJD9MAgGyAp7VJqzq2dJVg4eEXYE"
      />
    </div>
  )
}

export default LanderInvoiceEntry
